{
  "collectionLabel": "Προτάσεις"
}
